import * as React from "react";
import SEO from "../components/seo";
import Layout from "../components/layout";
import SimpleHero from "../components/v2/simple-hero";
import HeadlineBanner from "../components/v2/headline-banner";
import FiftyFiftyHorizontal from "../components/v2/fifty-fifty-horizontal";
import ImageComparison from "../components/v2/image-comparison";
import MediaSlider from "../components/v2/media-slider";
import GetUpdates from "../components/v2/get-updates";
import DetailsFooter from "../components/v2/details-footer";

// Hooks
import useBoulderingProjectPageImages from "../hooks/useBoulderingProjectPageImages";
import ArrowLink from "../components/global/arrow-link";

const BoulderingProject = () => {
  return (
    <Layout
      className="template-details"
      bodyTheme="light"
      isFooter={false}
      headerLayout="mobile"
    >
      <SEO title="Bouldering Project" />
      <SimpleHero
        contentData={
          {
            pre_title: "Bouldering",
            title: "Project",
          }
        }
        imageData={useBoulderingProjectPageImages({name: "bouldering-project-1"})}
      />
      <HeadlineBanner
        className="spacing spacing--general"
        pre_title="Real People. Real Movement."
        title="Real Connection"
      />
      <FiftyFiftyHorizontal
        imageData={useBoulderingProjectPageImages({name: "bouldering-project-2"})}
      >
        <p>Bouldering Project creates spaces for people to gather, ignite projects, and engage in health, friendship, and purpose. At this 26,000-square-foot indoor gym, you decide what climbing means to you, how you want to move, and why. In addition to world-class climbing, Salt Lake Bouldering Project will offer a yoga and fitness studio. They’ll also host classes and camps throughout the year.</p>
        <p className="flex-copy">
          <span>Open Weekdays, 7AM-11PM and</span>
          <span>Weekends, 8AM-10PM</span>
          <span><a className="dark" href="tel: +1 (801) 441-1387">(801) 441-1387</a></span>
          <span>
            <ArrowLink
              isExternalLink={true}
              to={"https://saltlakeboulderingproject.com/"}
              text="Learn More"
              theme="dark-body"
            />
          </span>
        </p>
      </FiftyFiftyHorizontal>
      <ImageComparison
        className="spacing spacing--general"
        generalImage={useBoulderingProjectPageImages({name: "bouldering-project-3"})}
      />
      <HeadlineBanner
        pre_title="The"
        title="Routesetting"
      />
      <FiftyFiftyHorizontal
        className="spacing spacing--general"
        mediaPosition="left"
        contentColumns={5}
        contentOffset={1}
        mediaColumns={6}
        mediaOffset={0}
        imageData={useBoulderingProjectPageImages({name: "bouldering-project-4"})}
      >
        <p>Circuits are among the most defining features of the Bouldering Project. They provide a framework whereby the diversity of people inside the gym can enjoy and measure experience in a way that is in tune with them. These circuits welcome new climbers to find their own path into the sport, help regulars add new dimensions to their sessions, and are a powerful training tool used by many elite athletes for mental and physical training.</p>
      </FiftyFiftyHorizontal>
      <MediaSlider
        className="spacing spacing--general"
        slides={[
          {
            imageData: useBoulderingProjectPageImages({name: "bouldering-project-5"}),
            description: "",
          },
          {
            imageData: useBoulderingProjectPageImages({name: "bouldering-project-6"}),
            description: "",
          },
          {
            imageData: useBoulderingProjectPageImages({name: "bouldering-project-7"}),
            description: "",
          },
          {
            imageData: useBoulderingProjectPageImages({name: "bouldering-project-8"}),
            description: "",
          },
          {
            imageData: useBoulderingProjectPageImages({name: "bouldering-project-9"}),
            description: "",
          },
        ]}
      />
      <GetUpdates
        className="spacing spacing--general"
      />
      <DetailsFooter
        imageData={useBoulderingProjectPageImages({name: "bouldering-project-10"})}
        imageDataHover={useBoulderingProjectPageImages({name: "bouldering-project-11"})}
        linkData={{
          title: "Read Story",
          project_url: "/all-together-skatepark/",
        }}
        pre_title="Up Next"
        title="All Together SkatePark"
      />
    </Layout>
  )
}

export default BoulderingProject
